import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AddNewPlantTreesComponent } from './add-new-plant-trees/add-new-plant-trees.component';
import { ListOfPlantsTreesComponent } from './list-of-plants-trees/list-of-plants-trees.component';
import { PlantDetailsComponent } from './plant-details/plant-details.component';
import { PrintQrCodeComponent } from './print-qr-code/print-qr-code.component';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ImageCropperModule } from 'ngx-image-cropper';
import { EditPlantTreesComponent } from './edit-plant-trees/edit-plant-trees.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { BulkUploadPreviewComponent } from './bulk-upload-preview/bulk-upload-preview.component';
import { HttpClientModule } from '@angular/common/http';
import { BulkQrCodeDownloadComponent } from './bulk-qr-code-download/bulk-qr-code-download.component';

const routes: Routes = [
  { path: '', component: AddNewPlantTreesComponent },
  { path: 'listplants', component: ListOfPlantsTreesComponent },
  { path: 'plant-details/:id', component: PlantDetailsComponent },
  { path: 'print-qr-code/:id', component: PrintQrCodeComponent },
  { path: 'edit-plant-trees/:id', component: EditPlantTreesComponent },
  { path: 'bulk-upload', component: BulkUploadComponent },
  { path: 'bulk-upload-preview', component: BulkUploadPreviewComponent },
];

@NgModule({
  declarations: [
    AddNewPlantTreesComponent,
    ListOfPlantsTreesComponent,
    PlantDetailsComponent,
    PrintQrCodeComponent,
    EditPlantTreesComponent,
    BulkUploadComponent,
    BulkUploadPreviewComponent,
    BulkQrCodeDownloadComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    AngularSvgIconModule.forRoot(),
    ImageCropperModule,
    CarouselModule,
    HttpClientModule
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LandscapingModule {}
